// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".list-inputs-fracionamento-container + .list-inputs-fracionamento-container {\n  margin-top: 15px;\n  padding-top: 15px;\n  border-top: 1px solid #ccc;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
